import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withFetch } from 'shared/hocs/withFetch';
import { withTranslate } from 'shared/hocs/withTranslate';
import { enqueueNotification } from 'shared/actions/notifications';
import NOTIFICATION_TYPES from 'shared/actions/notificationTypes';
import API from 'shared/constants/api';
import { getDisplayName } from 'shared/helpers/common';

const withDialogs = WrappedComponent => {
  const Component = class extends React.Component {
    static displayName = `withDialogs(${getDisplayName(WrappedComponent)})`;
    static contextTypes = {
      store: PropTypes.shape(),
    };

    static propTypes = {
      user: PropTypes.shape().isRequired,
      enqueueNotification: PropTypes.func.isRequired,
      fetch: PropTypes.func.isRequired,
      t: PropTypes.func.isRequired,
    };

    getVerifiedPhone = () => {
      const { user: stateUser } = this.props;
      const { user } = stateUser;

      return (user && user.phones && user.phones.find(phone => !!phone.is_verified)) || null;
    };

    handleSendMessage = async (textareaMsg, advertId) => {
      const {
        fetch,
        user: { token, user },
      } = this.props;
      const phone = this.getVerifiedPhone();

      if (user && token) {
        const data = {
          sender_name: user.name || user.email,
          sender_phone: phone && phone.number,
          text: textareaMsg,
          message_type: 'question',
          details: {},
        };
        await this.sendMsg(fetch, advertId, token, data);
      }
    };

    sendMsg = async (fetch, advertId, token, data) => {
      await fetch(API.SEND_MESSAGES(advertId), {
        method: 'POST',
        headers: {
          Authorization: `JWT ${token}`,
        },
        body: JSON.stringify(data),
      }).then(r => {
        if (r.status) {
          this.props.enqueueNotification({
            text: this.props.t('Сообщение отправлено'),
            type: NOTIFICATION_TYPES.SUCCESS,
          });
          r.json();
        }
      });
    };

    render() {
      return (
        <WrappedComponent
          handleSendMessage={this.handleSendMessage}
          verifiedPhone={this.getVerifiedPhone()}
          {...this.props}
        />
      );
    }
  };

  const mapStateToProps = ({ user }) => ({ user });
  const mapDispatchToProps = { enqueueNotification };

  return connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withFetch(withTranslate(Component)));
};

export default withDialogs;



// WEBPACK FOOTER //
// ./src/shared/hocs/withDialogs.js